import React, { Component } from "react";
import { Button, Icon, message } from 'antd';
import { NHConfirm } from "../../../common/NHModal";
import NHFetch from "../../../../utils/NHFetch";
import NHTable from '../../../common/NHTable';
import NHModal from "../../../common/NHModal";
import ChooseRangeForm from './choose-range-form';
import PropTypes from 'prop-types';
import NHSelector from "../../../common/NHSelector";
import getSize from "../../../../utils/getSize";
import css from '../index.css';

const basicUrl = '/lcpz/';

/**
 * 流程学生管理
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-12 11:58:40
 * Version: 1.0
 * Modify log:
 */
class StudentMng extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showOperationBtn: false, //是否显示操作按钮
            studentNumber: 0,
        }
    }

    //选择范围
    handleSetRangeBtnClick = () => {
        this.nhModal.show();
    }

    //设置流程应用范围——保存
    handleModalOk = (stopLoading) => {
        this.nhForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }else if(formData.bjid===undefined&&formData.qxxs===false&&formData.xslbm===undefined&&formData.xyid===undefined&&formData.zyid===undefined){
                message.warning("未输入如何条件，无添加学生！");
                this.nhModal.close();
                this.refs.nhTable.filterTableData();
                this.setState({ studentsNumber: 0 });
                stopLoading();
                return;
            }else{
                const initFormData = this.props.initFormData;
                if (initFormData) {
                    let lcid = initFormData.PKID || '';
                    formData.lcid = lcid;
                }
                NHFetch(basicUrl + 'insertStuRange', 'POST', formData)
                    .then(res => {
                        if (res) {
                            message.success("操作成功！");
                            this.nhModal.close();
                            this.refs.nhTable.filterTableData();
                        }
                        stopLoading();
                    }).catch(err => stopLoading());
            }
        });
    }

    changeForm = (value) => {
        this.nhForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let data = formData;
            for (let key of Object.keys(value)) {
                data[key] = value[key];
            }
            NHFetch(basicUrl + 'getCountByParams', 'POST', data)
                .then(res => {
                    if (res) {
                        if (res.data > 0) {
                            this.setState({ studentNumber: res.data });
                        } else {
                            this.setState({ studentNumber: 0 });
                        }
                    }
                })
        });
    }

    //分配学生按钮回调
    handleAddStuBtnClick = () => {
        this.nhSelector.show();
    }

    //确定分配学生
    handleSelectorOk = (result) => {
        const xsid = result.selectedKeys || [];
        let formData = {};
        formData.xsid = xsid;
        const initFormData = this.props.initFormData;
        if (initFormData) {
            let lcid = initFormData.PKID || '';
            formData.lcid = lcid;
        }

        NHFetch(basicUrl + 'insertStu', 'POST', formData)
            .then(res => {
                if (res) {
                    message.success("分配成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定移除该学生？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定移除选中的多个学生？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要移除的学生！");
        }
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteStudentByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("移除成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    // table选择后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }



    render() {
        
        const columns = [
            {
                title: '序号',
                dataIndex: 'RN',
                width: '60px',
                render: (text, record, index) => {
                  return <div><span>{index + 1}</span></div>;
                },
                dataIndex: 'ROW_ID'
            }, {
                title: '姓名',
                width: '100px',
                dataIndex: 'XM',
                searchType:"input"
            }, {
                title: '性别',
                width: '80px',
                key: 'xb',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '考生号',
                width: '120px',
                dataIndex: 'KSH',
                searchType:"input"
            }, {
                title: '学号',
                width: '120px',
                dataIndex: 'XH',
                searchType:"input"
            }, {
                title: '入学年份',
                width: '120px',
                dataIndex: 'RXNF',
                searchType:"select"
            }, {
                title: '学生类别',
                width: '120px',
                dataIndex: 'XSLB',
                searchType:"select"
            }, {
                title: '学院名称',
                width: '120px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业名称',
                width: '120px',
                dataIndex: 'ZYMC',
                searchType:"select"
            }, {
                title: '班级名称',
                width: '120px',
                dataIndex: 'BJMC',
                searchType:"select"
            }
        ];

        const action = [
            { title: '移除', onClick: this.handleSingleDeleteBtnClick },
        ];

        const initFormData = this.props.initFormData;

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 218}} >
                <NHTable ref="nhTable"
                    rowKey={record => record.PKID}
                    sign={'zhxg_yxxt_lcgl_lcpz_lcyyfw_queryPage'}
                    columns={columns}
                    action={action}
                    initParams={{ S_lcid_EQ: initFormData.PKID }}
                    rowSelectionChange={this.rowSelectionChange}
                >
                    <Button.Group>
                        <Button type="primary" onClick={this.handleSetRangeBtnClick}>
                            <Icon type="team" />批量添加
                        </Button>
                        <Button type="primary" onClick={this.handleAddStuBtnClick}>
                            手动添加<Icon type="user-add" />
                        </Button>
                    </Button.Group>
                    {
                        this.state.showOperationBtn &&
                        <Button type="danger" ghost style={{ marginLeft: 10 }}
                            onClick={this.handleMultiDeleteBtnClick}>移除</Button>
                    }
                </NHTable>
                <NHModal ref={modal => this.nhModal = modal} width={720} title={'添加学生'} onOk={this.handleModalOk}>
                    <ChooseRangeForm ref={(form) => this.nhForm = form} studentNumber={this.state.studentNumber} onChange={this.changeForm} />
                </NHModal>
                <NHSelector ref={selector => this.nhSelector = selector} title={'学生选择器'}
                    sign={"zhxg_yxxt_lcyyfw_student_selector"}
                    onOk={this.handleSelectorOk} />
            </div>
        );
    }
}

StudentMng.propTypes = {
    initFormData: PropTypes.object //初始数据
}


export default StudentMng;



// WEBPACK FOOTER //
// ./components/lcgl/lcpz/student-mng/index.js